import { PathUtils } from "@/utils/path.utils"

export interface HomeThumbnailItem {
  id: string
  uri: string
  thumbUrl: string
  srcset: string
}

interface KirbyThumbResult {
  id: string
  uri: string
  w480: string | null
  w960: string | null
  w1440: string | null
}

const API = PathUtils.strip(import.meta.env.VITE_KIRBY_URL) + "/api/query"

const thumbSelect = {
  id: "page.id",
  uri: "page.uri",
  w480: "page.thumbnail.toFile.resize(480).url",
  w960: "page.thumbnail.toFile.resize(1280).url",
  w1440: "page.thumbnail.toFile.resize(1600).url",
}

export const fetchThumbnailsForUris = async (
  uris: string[],
): Promise<HomeThumbnailItem[]> => {
  if (!uris.length) return []
  const idsString = uris.map(u => `"${u}"`).join(", ")
  const response = await fetch(API, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query: `site.find([${idsString}])`,
      select: thumbSelect,
    }),
  })
  const json = await response.json()
  const results = (json.result ?? []) as KirbyThumbResult[]
  return results
    .filter(item => !!item.w480)
    .map(item => ({
      id: item.id,
      uri: item.uri,
      // The jackpot preloads + flashes this `thumbUrl` during the spin, so use a
      // mid-tier variant (1280px) — sharp enough for the big rows while still
      // light to preload. The settled result upgrades to 2048 via `srcset`.
      thumbUrl: (item.w960 ?? item.w480)!,
      srcset: [
        item.w480 && `${item.w480} 480w`,
        item.w960 && `${item.w960} 960w`,
        item.w1440 && `${item.w1440} 1440w`,
      ]
        .filter(Boolean)
        .join(", "),
    }))
}
